import { Directive } from '@angular/core';

@Directive({
  selector: '[appCreateDateRangeValidator]'
})
export class CreateDateRangeValidatorDirective {

  constructor() { }

}
